import { useMutation } from "@apollo/react-hooks";

import { Learner, Test } from "@hubcapp/types";
import createTestMutation from "../graph-ql/createTest.graphql";
import testDetails from "../graph-ql/testDetails.graphql";

const useMutationCreateTest = (instructorId: string, learnerId: string) =>
  useMutation(createTestMutation, {
    optimisticResponse: (variables: Test & { learnerId: string }) => ({
      createTest: { ...variables, __typename: "Test" },
    }),
    update: (proxy, { data }) => {
      if (data) {
        const learnerQuery = proxy.readQuery<{ learner: Learner }>({
          query: testDetails,
          variables: {
            id: learnerId,
            instructorId: instructorId,
          },
        });

        if (learnerQuery) {
          const testIds = (learnerQuery.learner.tests || []).map(
            ({ id }) => id,
          );
          const exists =
            data?.createTest?.id && testIds.includes(data.createTest.id);

          if (exists) {
            return;
          }

          proxy.writeQuery({
            query: testDetails,
            variables: {
              id: learnerId,
              instructorId: instructorId,
            },
            data: {
              learner: {
                ...learnerQuery.learner,
                tests: [...learnerQuery.learner.tests, data.createTest],
              },
            },
          });
        }
      }
    },
  });

export default useMutationCreateTest;
